export const SDK_VERSION = '3.1.1';
export const BEACON_VERSION = '3';
//# sourceMappingURL=constants.js.map